import { createSlice } from "@reduxjs/toolkit";

const sessionSlice = createSlice({
  name: "session",
  initialState: {
    token: null,
    user: null,
    isSessionChecked: false,
    isLoading: false,
    error: null,
  },
  reducers: {
    setSession(state, action) {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.isSessionChecked = true;
      state.error = null;
      state.isLoading = false;
    },
    clearSession(state) {
      state.token = null;
      state.user = null;
      state.isSessionChecked = true;
      state.error = null;
      state.isLoading = false;
    },
    setSessionChecked(state) {
      state.isSessionChecked = true;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setSession, clearSession, setSessionChecked, setLoading, setError } = sessionSlice.actions;
export default sessionSlice.reducer;
